import { render, staticRenderFns } from "./TodoBlock.vue?vue&type=template&id=5610b4b2&"
import script from "./TodoBlock.vue?vue&type=script&lang=js&"
export * from "./TodoBlock.vue?vue&type=script&lang=js&"
import style0 from "./TodoBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports